/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  business: {
    defaultMessage: 'Business',
    id: 'AuthenticationPicker.business',
  },
  corporate: {
    defaultMessage: 'Corporate',
    id: 'AuthenticationPicker.corporate',
  },
  personal: {
    defaultMessage: 'Personal',
    id: 'AuthenticationPicker.personal',
  },
  loginType: {
    defaultMessage: 'Login type',
    id: 'AuthenticationPicker.loginType',
  },
  whichWayToLogin: {
    defaultMessage: 'How do you want to log in?',
    id: 'AuthenticationPicker.whichWayToLogin',
  },
});
